<template>
  <el-row style="width: 202px; line-height: 55px;">
    <el-select
      v-model="reslut.areaL1Code"
      placeholder="省"
      clearable
      @change="change1"
      size="small"
      style="width:202px"
    >
      <el-option
        v-for="item in areaList.options1"
        :key="item.code"
        :label="item.name"
        :value="item.code"
      />
    </el-select>
    <el-select
      v-model="reslut.areaL2Code"
      filterable
      placeholder="市"
      clearable
      @change="change2"
      size="small"
      style="width:202px"
    >
      <el-option
        v-for="item in areaList.options2"
        :key="item.code"
        :label="item.name"
        :value="item.code"
      />
    </el-select>
    <el-select
      v-model="reslut.areaL3Code"
      filterable
      placeholder="区"
      clearable
      @change="change3"
      size="small"
      style="width:202px"
    >
      <el-option
        v-for="item in areaList.options3"
        :key="item.code"
        :label="item.name"
        :value="item.code"
      />
    </el-select>
  </el-row>
</template>
<script>
import Vue from "vue";
import Api from "../../api.js";
const api = new Api();
import { Select, Row, Col, Option } from "element-ui";
Vue.use(Select)
  .use(Row)
  .use(Col)
  .use(Option);
export default {
  props: {
    editdata: {
      type: Object,
      default: () => {
        return null;
      }
    }
  },
  data() {
    return {
      areaValue: [],
      areaList: {
        options1: [],
        options2: [],
        options3: []
      },
      reslut: {
        areaL1Code: "",
        areaL1Name: "",
        areaL2Code: "",
        areaL2Name: "",
        areaL3Code: "",
        areaL3Name: ""
      },
      props: {
        value: "label",
        children: "cities"
      }
    };
  },
  watch: {
    async editdata(val, oldVal) {
      const self = this;
      if (self.areaList.options1.length == 0) {
        self.areaList.options1 = await self.getCodeInfo(0);
      }
      self.reslut.areaL1Code = val.code1;
      if (val.code1 != "") {
        self.areaList.options1.map(v => {
          v.code == val.code1 ? (self.reslut.areaL1Name = v.name) : "";
        });
        self.areaList.options2 = await self.getCodeInfo(val.code1);
      }
      if (val.code2 != "") {
        self.areaList.options2.map(v => {
          v.code == val.code2 ? (self.reslut.areaL2Name = v.name) : "";
        });
        self.areaList.options3 = await self.getCodeInfo(val.code2);
      }
      self.reslut.areaL2Code = val.code2;
      self.reslut.areaL3Code = val.code3;
      if (val.code3 != "") {
        self.areaList.options3.map(v => {
          v.code == val.code3 ? (self.reslut.areaL3Name = v.name) : "";
        });
      }
    }
  },
  async created() {
    this.areaList.options1 = await this.getCodeInfo(0);
  },
  methods: {
    async change1(val) {
      const self = this;
      if (val == "" || val == null) {
        self.reslut.areaL1Name = "";
      } else {
        this.areaList.options1.map(v => {
          v.code == val ? (self.reslut.areaL1Name = v.name) : "";
        });
        this.areaList.options2 = await this.getCodeInfo(val);
      }
      this.areaList.options3 = [];
      this.reslut.areaL2Code = "";
      this.reslut.areaL2Name = "";
      this.reslut.areaL3Code = "";
      this.reslut.areaL3Name = "";
      this.$emit("change", this.reslut);
    },
    async change2(val) {
      const self = this;
      if (val == "" || val == null) {
        self.reslut.areaL2Name = "";
      } else {
        this.areaList.options2.map(v => {
          v.code == val ? (self.reslut.areaL2Name = v.name) : "";
        });
        this.areaList.options3 = await this.getCodeInfo(val);
      }
      this.reslut.areaL3Code = "";
      this.reslut.areaL3Name = "";
      this.$emit("change", this.reslut);
    },
    async change3(val) {
      const self = this;
      this.areaList.options3.map(v => {
        v.code == val ? (self.reslut.areaL3Name = v.name) : "";
      });
      this.$emit("change", this.reslut);
    },
    getCodeInfo(pcode) {
      return api.getAreaCode(pcode);
    }
  }
};
</script>
<style >
.ms-layout .el-select {
  line-height: 55px;
}
</style>
